import React from "react";
import { PieChart, Pie, Cell, Tooltip } from "recharts";
import "./HalfDonutPieChart.scss";

const HalfDonutPieChart = ({
  data = [],
  colors = ["#ff6b6b", "#5b9df9"],
  showValues = false,
  innerRadius = 37,
  outerRadius = 55,
  width = 114,
  height = 58,
  startAngle = 180,
  endAngle = 0,
  cornerRadius = 3,
  cx = 50,
  cy = 54,
  formatValue = (val) => `${Number(val).toFixed(2)}%`,
}) => {
  if (!Array.isArray(data) || data.length === 0) return <span>-</span>;

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      return (
        <div
          style={{
            borderRadius: "4px",
            border: "1px solid var(--table-stroke, #c6cce0)",
            background: "var(--Box, #fff)",
            boxShadow: "6px 6px 16px 0px rgba(0, 0, 0, 0.15)",
            fontSize: "12px",
            fontFamily: "Gilroy",
            padding: "8px",
            width: "fit-content",
            textAlign: "left",
            textWrap: "nowrap",
          }}
        >
          {payload.map((entry, index) => {
            const fillColor = entry?.payload?.fill || entry?.color || "#ccc";
            return (
              <div
                key={index}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "4px",
                  marginBottom: "4px",
                  width: "fit-content",
                }}
              >
                <div
                  style={{
                    width: "10px",
                    height: "10px",
                    borderRadius: "2px",
                    backgroundColor: fillColor,
                  }}
                />
                <span>{entry.name}:</span>
                <strong>{Number(entry.value)}</strong>
              </div>
            );
          })}
        </div>
      );
    }

    return null;
  };

  return (
    <div className="half-donut-wrapper">
      <PieChart width={width} height={height}>
        <Tooltip
          formatter={(value, name) => [value, name]}
          content={<CustomTooltip />}
          wrapperStyle={{
            zIndex: 10,
            pointerEvents: "none",
          }}
          position={{ x: -40, y: -40 }}
        />
        <Pie
          data={data}
          startAngle={startAngle}
          endAngle={endAngle}
          innerRadius={innerRadius}
          outerRadius={outerRadius}
          cornerRadius={cornerRadius}
          dataKey="value"
          cx={cx}
          cy={cy}
        >
          {data.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={colors[index % colors.length]} />
          ))}
        </Pie>
      </PieChart>
    </div>
  );
};

export default HalfDonutPieChart;
